"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Datacamp = function Datacamp(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.156,5.579l-0.194,0.269c-0.24-0.247-0.819-0.509-0.86-0.528l0.155-0.411 l-0.014-0.01c-0.024-0.016-0.05-0.028-0.078-0.037c-0.873-0.329-1.675-0.333-2.768-0.017l0.517,1.381h-0.01 C10.18,6.461,9.64,7.114,9.581,7.187L8.865,6.676C8.47,7.198,8.19,8.142,8.19,8.867H7.277c0.007,0.656,0.126,1.794,0.9,2.738 l0.682-0.521c0.623,0.916,1.925,1.581,3.015,1.468l-0.016-1.906h0.014v0.026c0.273,0.08,0.843-0.093,1.092-0.289l0.517,0.692 c0.543-0.185,0.964-1.238,1.008-1.351l0.822,0.281l0.001,0.001c0.22-0.763,0.228-1.572,0.023-2.339l-0.001,0.001V7.659 c0.001,0.002,0.001,0.005,0.001,0.007l0.294-0.107C15.411,6.734,14.883,6.025,14.156,5.579z M12.168,9.258 c-0.341,0.142-0.735,0.063-0.995-0.2c-0.261-0.265-0.339-0.66-0.198-1.004c0.142-0.344,0.475-0.568,0.845-0.568c0,0,0,0,0,0h0.001 c0,0,0,0,0,0c0.505,0.003,0.913,0.415,0.912,0.92C12.732,8.779,12.509,9.116,12.168,9.258z M22.662,3.692L12.139,0.043 c-0.162-0.057-0.338-0.057-0.499,0L1.341,3.695C1.006,3.814,0.798,4.147,0.836,4.5l1.453,13.842 c0.025,0.248,0.17,0.469,0.387,0.591l8.961,4.973C11.749,23.967,11.875,24,12.003,24h0.001c0.131,0,0.26-0.034,0.373-0.099 l8.739-4.973c0.209-0.119,0.35-0.333,0.38-0.575l1.67-13.842C23.208,4.152,23,3.812,22.662,3.692z M16.764,12.917 c0,0-0.127,0.144,0.051,0.445c0.179,0.299,0.23,0.299-0.102,0.612c0.256,0.222,0.256,0.406-0.127,0.58 c0.009,0.618,0.134,1.171-0.651,1.218c-0.785,0.046-1.78-0.482-2.039,0.939c-0.259,1.419-0.192,0.888-0.269,1.244H8.082 c0.69-1.902,1.28-4.001,0-5.032c-1.279-1.03-3.373-5.358,0.756-7.575c0.465-0.248,0.961-0.435,1.474-0.554L10.138,4.33l0.054-0.021 c0.017-0.007,1.774-0.684,3.293,0.062l0.05,0.025l-0.183,0.416c0.979,0.22,1.709,0.582,1.98,0.751 c0.614,0.382,1.429,0.99,1.507,1.566c0.077,0.575-0.664,0.286-0.664,0.286c0.46,1.117,0.485,1.918,0.28,2.768v0.001 c-0.204,0.848,0.945,1.725,0.92,2.342C17.3,12.812,16.764,12.917,16.764,12.917z"
  }));
};

Datacamp.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Datacamp.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Datacamp;
exports.default = _default;